/* OfferteCTA - Call-to-action section linking to the projectprijs aanvragen page
 * Updated: Solid white landing-page card with rounded-xl corners, subtle ring, and no gradients
 */

import { motion } from 'framer-motion';
import { ArrowRight, FileText } from 'lucide-react';

export default function OfferteCTA() {
  return (
    <section className="mb-16">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="p-8 text-center sm:p-12 lg:p-16"
      >
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-md bg-[#e7e1d6] text-[#1e2b22]">
          <FileText className="h-7 w-7" />
        </div>
        <h2 className="mt-6 text-3xl tracking-[-0.035em] text-[#1e2b22] md:text-4xl">Liever een prijs op maat?</h2>
        <p className="mx-auto mt-4 mb-8 max-w-2xl text-base leading-7 text-[#5a6552] sm:text-lg sm:leading-8">
          Nog niet gevonden wat je zoekt of groter dan gemiddeld? Wij maken graag een vrijblijvende projectprijs die precies aansluit op jouw groene plannen.
        </p>
        <a
          href="/projectprijs-aanvragen"
          className="group inline-flex min-h-12 items-center justify-center gap-3 rounded-md bg-[#1e2b22] px-6 text-sm font-semibold text-white shadow-[0_10px_30px_rgba(30,43,34,0.18)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-[#5a6552] hover:shadow-[0_14px_34px_rgba(30,43,34,0.2)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1e2b22] focus-visible:ring-offset-2 focus-visible:ring-offset-white sm:px-7"
        >
          Projectprijs aanvragen
          <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      </motion.div>
    </section>
  );
}
